import { render, staticRenderFns } from "./dashboardCrm.vue?vue&type=template&id=3dd2191c&"
import script from "./dashboardCrm.vue?vue&type=script&lang=js&"
export * from "./dashboardCrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports